import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import { url } from '../../../js/api/endpoint';
import themes from '../../../js/stores/theme.js';
import language from '../../../js/stores/language.js';
import buyoutDeposit from '../../../js/stores/buyout-deposit.js';
import carLoanIssue from '../../../js/stores/car-loan-issue.js';
import file from '../../../js/stores/file.js';
import carLoanItemLibrary from '../../../js/controllers/car-loan-item-lib.js';
import downloadLoanAgreementDoc from '../../../js/components/loan-agreement-document.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var issueData = {};
  var loanIssuePhotoBrowser;
  var penaltyList = [];
  var currentTotalFine = 0;
  var currentLoanIssueId = 0;
  var fuelValue = {
    0: locale.translate('general.empty'),
    12.5: '1/8',
    25: '1/4',
    37.5: '3/8',
    50: '1/2',
    62.5: '5/8',
    75: '3/4',
    87.5: '7/8',
    100: locale.translate('general.full')
  };
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data, filteredList, loanPhotoList, loanImageList, i, urlFile;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          currentLoanIssueId = props.CarLoanIssueId;
          data = {
            loanIssueId: currentLoanIssueId,
            languageCode: language.getters.Name.value
          };
          _context.next = 1;
          return carLoanIssue.dispatch('getIssuePenaltyListLocalized', data);
        case 1:
          penaltyList = _context.sent;
          if (!(penaltyList.status !== undefined && penaltyList.status !== 200)) {
            _context.next = 2;
            break;
          }
          console.log(penaltyList.data.messages.error);
          return _context.abrupt("return");
        case 2:
          filteredList = penaltyList.filter(function (item) {
            return item.CarPenaltyCostIsUsed > 0;
          });
          currentTotalFine = 0;
          filteredList.forEach(function (item) {
            currentTotalFine += Number(item.PenaltyCostValue);
          });
          _context.next = 3;
          return file.dispatch('getCarLoanIssueImages', props.CarLoanId);
        case 3:
          loanPhotoList = _context.sent;
          if (!(loanPhotoList.status !== undefined && loanPhotoList.status !== 200)) {
            _context.next = 4;
            break;
          }
          console.log(loanPhotoList.data.messages.error);
          return _context.abrupt("return");
        case 4:
          loanImageList = [];
          for (i = 0; i < loanPhotoList.length; i++) {
            if (!(loanPhotoList[i].FilePath.length == 0 && loanPhotoList[i].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(loanPhotoList[i].FilePath, "/").concat(loanPhotoList[i].FileName);
              loanImageList.push(urlFile);
            }
          }
          if (loanImageList.length > 0) {
            loanIssuePhotoBrowser = $f7.photoBrowser.create({
              photos: loanImageList,
              theme: themes.getters.Name.value
            });
          }
          $update();
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var openCarLoanIssueImages = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            loanIssuePhotoBrowser.open();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function openCarLoanIssueImages() {
      return _ref3.apply(this, arguments);
    };
  }();
  var cancelRefund = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            $f7.dialog.confirm(locale.translate('admin.sections.refund.edit.tagCancelIssue'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function (_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 1;
                    return execSave('cancelLoanIssue');
                  case 1:
                    $f7.toast.show({
                      text: locale.translate('admin.sections.refund.edit.tagCancelMessage')
                    });
                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function cancelRefund() {
      return _ref4.apply(this, arguments);
    };
  }();
  var saveRefund = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            $f7.dialog.confirm(locale.translate('admin.sections.refund.edit.tagAcceptIssue'), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              return _regeneratorRuntime.wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 1;
                    return execSave('closeLoanIssue');
                  case 1:
                    $f7.toast.show({
                      text: locale.translate('admin.sections.refund.edit.tagAcceptMessage')
                    });
                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            })));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function saveRefund() {
      return _ref6.apply(this, arguments);
    };
  }();
  var execSave = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var method,
        formContinueLoan,
        result,
        _args7 = arguments;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            method = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 'cancelLoanIssue';
            formContinueLoan = new FormData();
            formContinueLoan.append("CarLoanIssueId", props.CarLoanIssueId);
            _context7.next = 1;
            return carLoanIssue.dispatch(method, formContinueLoan);
          case 1:
            result = _context7.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context7.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context7.abrupt("return");
          case 2:
            props.CarLoanIssueStatusId = 5;
            $update();
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function execSave() {
      return _ref8.apply(this, arguments);
    };
  }();
  var getDownloadDocument = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
      var obj, anchor, carLoanId, _t;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            obj = {};
            $f7.preloader.show();
            _context8.prev = 1;
            e.preventDefault();
            anchor = e.target.closest("a");
            carLoanId = anchor.dataset.carLoanId;
            _context8.next = 2;
            return carLoanItemLibrary.getLoanData(carLoanId, {});
          case 2:
            obj = _context8.sent;
            downloadLoanAgreementDoc(obj.props);
            $f7.preloader.hide();
            _context8.next = 4;
            break;
          case 3:
            _context8.prev = 3;
            _t = _context8["catch"](1);
            $f7.preloader.hide();
            console.error(_t);
          case 4:
            return _context8.abrupt("return", obj);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function getDownloadDocument(_x) {
      return _ref9.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="popup car-loan-issue-popup">
  <div class="view">
    <div class="page" data-name="car-loan-issue-edit">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${locale.translate('general.edit')}</div>
          <div class="right">
            <a class="link popup-close">
              <i class="icon material-symbols-outlined color-red">cancel</i>
            </a>
          </div>
        </div>
      </div>
      <div class="page-content">
        <!--
        <div class="block-title">Current fine total: €${currentTotalFine}</div>
        -->
        <div class="block block-strong">
          <form id="buyout-deposit-form" class="list">
            <input id="buyout-deposit-id" name="BuyoutDepositId" type="hidden" value="${props.CarLoanIssueId}" />
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('user.edit.tabs[3]')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">directions_car</i> ${props.CarManufacturerName} ${props.CarModel} ${props.CarYear}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagLoan')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">date_range</i> ${props.CarLoanTag} / ${props.CarLoanStartDate} / ${props.CarLoanEndDate}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagUsers')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">person</i> ${props.LenderName} / ${props.BorrowerName}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagFuel')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">local_gas_station</i> ${fuelValue[parseFloat(props.CurrentFuelLevel)]} | ${fuelValue[parseFloat(props.ReturningFuelLevel)]} <i class="icon material-symbols-outlined color-teal">local_gas_station</i>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagPlace')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">location_on</i> ${props.AppointmentPlace} / ${props.ReturnAppointmentPlace}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagDate')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">date_range</i> ${props.AppointmentDate} / ${props.ReturnAppointmentDate}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagOdometer')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      <i class="icon material-symbols-outlined color-teal">swap_driving_apps_wheel</i> ${props.CurrentKilometers} / ${props.ReturningKilometers}
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div id="" class="item-title item-label">${locale.translate('admin.sections.refund.edit.tagIssueComment')}</div>
                    <div id="label" class="item-title item-label"></div>
                    <div class="item-input-wrap">
                      ${props.CarLoanIssueComment}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="block block-strong">
              <p class="grid grid-cols-3 xlarge-grid-cols-3">
                <div>
                  <a href="#" class="button button-small button-fill button-raised color-green" @click="${getDownloadDocument}" data-car-loan-id="${props.CarLoanId}">
                    <i class="icon material-symbols-outlined">download</i> ${locale.translate('general.document')}
                  </a>
                </div>
                <div>
                </div>
                <div>
                  <a href="#" class="button button-small button-fill button-raised color-green" @click="${openCarLoanIssueImages}">
                    <span class="material-symbols-outlined">photo_camera</span> ${locale.translate('admin.sections.refund.edit.tagIssueImages')}
                  </a>
                </div>
              </p>
            </div>
            ${penaltyList.length > 0 && $h`
            <div class="block-title">${locale.translate('admin.sections.refund.edit.tagMarkedIssues')}:</div>
            <div class="form list no-hairlines-md ${issueData.CarLoanIssueStatusId > 1 && $h`disabled`}">
              <ul>
                ${penaltyList.map((item) => $h`
                <li class="disabled">
                  <label class="item-content">
                    <div class="item-inner">
                      <div class="item-title">${item.LanguageKeyValue}</div>
                      <div class="item-after">
                        <div class="toggle">
                          <input type="checkbox" name="GetPenaltyValues" checked="${item.CarPenaltyCostIsUsed > 0 && $h`checked`}"/>
                          <span class="toggle-icon"></span>
                        </div>
                      </div>
                    </div>
                  </label>
                </li>
                `)}
              </ul>
            </div>
            `}
          </form>
          ${Number(props.CarLoanIssueStatusId) === 2 && $h`
          <div class="block block-strong">
            <p class="grid grid-cols-3 xlarge-grid-cols-3">
              <div>
                <a href="#" class="button button-small button-fill button-raised color-red" @click="${cancelRefund}">
                  <span class="material-symbols-outlined">close</span>${locale.translate('general.cancel')}
                </a>
              </div>
              <div></div>
              <div>
                <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveRefund}">
                  <span class="material-symbols-outlined">done</span>${locale.translate('general.accept')}
                </a>
              </div>
            </p>
          </div>
          `}
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '193325af5c';
export default framework7Component;